import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {StatusCode} from '../../assets/constants/constants';
import {getLottieFileContent} from '../../services/user';
import PageLoader from './loader/PageLoader';

type TranscriptProps = {
  transcriptLocation: string | undefined;
  isUserEnrolled: any | boolean;
  setIsLoadingTranscripts: React.Dispatch<React.SetStateAction<boolean>>;
  isLoadingTranscripts: boolean; 
};
export const Transcript: React.FC<TranscriptProps> = ({
  transcriptLocation,
  isUserEnrolled,
  setIsLoadingTranscripts,
  isLoadingTranscripts,
}) => {
  const { t } = useTranslation();
  const [content, setContent] = useState<string>('');

  const getContent = () => {
    setIsLoadingTranscripts(true);
    getLottieFileContent(transcriptLocation)
      .then((res: any) => {
        if (res?.status === StatusCode.SUCCESS) {
          setContent(res.data);
        }
      })
      .finally(() => {
        setIsLoadingTranscripts(false);
      });
  };

  useEffect(() => {
    if (isUserEnrolled) {
      getContent();
    }
  }, [isUserEnrolled]);

  return (
    <div className="">
      <h2 className="text-3xl font-barlowLight">{t('Common.transcripts')}</h2>
      {!isUserEnrolled ? (
        <div className="flex w-full justify-center text-2xl mb-10">
          {t('Common.viewTranscript')}
        </div>
      ) : isLoadingTranscripts ? (
        <PageLoader />
      ) : content ? (
        <div style={{ whiteSpace: 'pre-wrap' }}>{content}</div>
      ) : (
        <div className="flex w-full justify-center text-2xl mb-10">
          {t('Common.noTranscriptFound')}
        </div>
      )}
    </div>
  );
};
